import Monke from "../../img/2025/Jugo.jpeg";
const Puzzle6 = () => {
  return (
    <main style={{ padding: 24 }}>
      <h1>🔮 6. Jugo der Talahon – Das Symbolrätsel</h1>

      <p>
        Ooooh… ich bin Jugo… der Talahon… Ich sehe, was war… und was sein wird…
        In meinem Rätsel steckt Weisheit. Oder Wahnsinn. Finde heraus, welches.
      </p>
      <img src={Monke} style={{ maxWidth: "100%", marginBottom: "32px" }} />
      <p>
        <b style={{ fontSize: "1.2em" }}>
          Ich spreche in Zeichen:
          <br />
          ▲▲▼▲▼▲▼▼▲
          <br />
          Ersetze ▲ = +1, ▼ = -1 und beginne bei 4.
        </b>
      </p>
      <p>Der letzte Affe hat ein A im Namen – Huso! Er kackt gerade.</p>
    </main>
  );
};

export default Puzzle6;
